import React, { useState } from 'react';

import { LiveLogsButton } from '~/src/dash/components/live_logs/live-logs-button';
import { LiveLogsButtonV3 } from '~/src/dash/components/live_logs/live-logs-button-v3';
import { LiveLogsButtonV2 } from '~/src/dash/components/live_logs/live-logs-buttonV2';
import {
  ILiveLogsTabWrapper,
  LiveLogsPopup,
} from '~/src/dash/components/live_logs/live-logs-popup';

interface IProps {
  elements: ILiveLogsTabWrapper[];
  classes: any;
  useV2?: boolean;
  buttonText?: string;
  isFixedButton?: boolean;
  useV3?: boolean;
  backgroundColor?: string;
  textColor?: string;
  getLiveLogs: () => void;
  refreshingLiveLogs: boolean;
  refreshingLiveLogsTimestamp: string;
}

export function LiveLogsWrapper(props: IProps) {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      {props.useV3 && !props.useV2 && (
        <LiveLogsButtonV3
          onClick={() => setOpen(true)}
          buttonText={props.buttonText}
          isFixedButton={props.isFixedButton}
          backgroundColor={props.backgroundColor}
          textColor={props.textColor}
        />
      )}
      {props.useV2 && !props.useV3 && (
        <LiveLogsButtonV2
          onClick={() => setOpen(true)}
          buttonText={props.buttonText}
          isFixedButton={props.isFixedButton}
        />
      )}
      {!props.useV2 && !props.useV3 && (
        <LiveLogsButton onClick={() => setOpen(true)} isFixedButton={props.isFixedButton} />
      )}
      <LiveLogsPopup
        getLiveLogs={props.getLiveLogs}
        classes={props.classes}
        openLiveLogs={isOpen}
        onClose={() => setOpen(false)}
        elements={props.elements}
        refreshingLiveLogs={props.refreshingLiveLogs}
        refreshingLiveLogsTimestamp={props.refreshingLiveLogsTimestamp}
      />
    </>
  );
}
